import { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import { commonTranslationKeys } from '@dreryk/react-common';
import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../translations';

type ReceptionServiceRemoveConfirmationEventInterceptorProps = {
   readonly children: ReactNode;
   readonly receptionServiceName: string;
   readonly hasMorePractitioners: boolean;
};

export const ReceptionServiceRemoveConfirmationEventInterceptor = (
   props: ReceptionServiceRemoveConfirmationEventInterceptorProps
): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         shouldShowModal
         modalWidth={ModalWidth.NORMAL}
         testId={'receptionServiceRemoveConfirmation'}
         title={receptionServiceTranslationKeys.table.remove.receptionService.confirmation.title}
         confirmationButtonLabel={commonTranslationKeys.remove}
         content={
            <Trans
               i18nKey={
                  props.hasMorePractitioners
                     ? receptionServiceTranslationKeys.table.remove.receptionService.confirmation.content
                          .manyPractitioners
                     : receptionServiceTranslationKeys.table.remove.receptionService.confirmation.content
                          .onePractitioner
               }
               components={{ bold: <strong /> }}
               values={{
                  receptionServiceName: props.receptionServiceName,
               }}
            />
         }
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
